import React from 'react';
import classNames from 'classnames';
import { Snippet } from 'react-instantsearch/dom';
import { flow, compact, join } from 'lodash/fp';
import { Card } from 'ui';
import { LEARN_TYPES } from 'constants/config';
import { getContentAttribute } from 'utils/getContentAttribute';
import withContentData from './withContentData';
import Status from '../../shared/LearnContentCard/Status';
import DueDateBadge from '../../shared/LearnContentCard/DueDateBadge';

const compactJoin = flow(compact, join(''));

const isElement = hit => hit.content_type === LEARN_TYPES.ELEMENT;
const isSection = hit => hit.content_type === LEARN_TYPES.SECTION;

const buildUrl = (lessonUrl, hit) =>
  compactJoin([
    `${lessonUrl}?section_id=${hit.s_id}`,
    isElement(hit) && `#${hit.e_id}`,
  ]);

const LessonContentHit = ({ hit, contentData }) => (
  <Card
    url={buildUrl(contentData.links.view, hit)}
    className="LearnLessonContentHit"
  >
    <Card.Content className="LearnLessonContentHit-content" padding="medium">
      <div
        className={classNames('LearnLessonContentHit-match', {
          'LearnLessonContentHit-match--large': isSection(hit),
        })}
      >
        <Snippet hit={hit} attribute={getContentAttribute(hit)} />
      </div>
      <div className="LearnLessonContentHit-lessonTitle">
        {hit.lesson_title}
      </div>
      <div className="LearnLessonContentHit-footer">
        {(contentData.progress.dueDate ||
          contentData.progress.completedDate) && (
          <DueDateBadge rounded progress={contentData.progress} />
        )}
        <Status progress={contentData.progress} />
      </div>
    </Card.Content>
  </Card>
);

export default withContentData(LessonContentHit);
